import { IFacility } from '../models/facility';
import resources from '../resources';
import config from '../services/config';

export const BASE_DATA_LOADING = 'WEBSITE/BASE_DATA_LOADING';
export const BASE_DATA_LOAD_SUCCESS = 'WEBSITE/BASE_DATA_LOAD_SUCCESS';
export const BASE_DATA_LOAD_FAILED = 'WEBSITE/BASE_DATA_LOAD_FAILED';
export function loadBaseData() {
  return (dispatch) => {
    dispatch({ type: BASE_DATA_LOADING });

    let hostname = location.hostname;
    if (config.siteOverrideUrl) {
      hostname = config.siteOverrideUrl;
    }

    return resources.website
      .getBaseData(hostname)
      .then((result: IFacility) => {
        dispatch({ type: BASE_DATA_LOAD_SUCCESS, data: result });
        return result;
      })
      .catch((err) => {
        dispatch({ type: BASE_DATA_LOAD_FAILED, error: err });
        throw err;
      });
  };
}
